export const RequestsEnum = Object.freeze({
  REQUEST_FAILED: 'REQUEST_FAILED',
  REQUEST_FINISHED: 'REQUEST_FINISHED',
  REQUEST_STARTED: 'REQUEST_STARTED',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS'
});
